import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo13 } from "../../../routes/Module13";
import Sidebar from "../Sidebar";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import Imagen1 from "../../../images/modulo13/hojatexto.png";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad1Actividad8.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo13.content[0];
  const infoAct = modulo13.content[0].activities[9];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titlePrev: `${modulo13.content[0].name}: ${modulo13.content[0].activities[8].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[8].path}`,
    titleNext: `${modulo13.content[0].name}: ${modulo13.content[0].activities[10].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[10].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul>
        <li>
          Junto con un compañero, compañera o familiar, lean las tres razones
          por las que es importante adaptarse al territorio:
        </li>
      </ul>
      <img src={Imagen1} className="img-fluid" alt="Peruanos" />
      <ul className="mt-5">
        <li>
          Escojan una de las razones y conversen entre ustedes: ¿por qué les
          parece una buena razón?
        </li>
      </ul>
      <div className="row">
        <div className="col-lg-10 col-12">
          <textarea rows={3} className="form-control" />
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida a un estudiante que lea en voz alta la primera indicación y las
            razones que se plantean en la actividad: Escojan una de las razones
            y conversen entre ustedes: ¿por qué les parece una buena razón?
          </li>
          <li>
            Lea la última indicación: Escojan una de las razones y conversen
            entre ustedes: ¿por qué les parece una buena razón? Retome las
            respuestas dadas y comente las razones. Puede pensar en algunos
            casos que representen la situación.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
